import { render, staticRenderFns } from "./DetailPengujian.vue?vue&type=template&id=026afb14&scoped=true&"
import script from "./DetailPengujian.vue?vue&type=script&lang=js&"
export * from "./DetailPengujian.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "026afb14",
  null
  
)

export default component.exports